import React, { Component } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import "swiper/css";
import 'swiper/css/pagination';
import parse from 'html-react-parser'

export class Testimonial extends Component {

    constructor() {
        super();
        this.state = {
            tmonials: []
        }
    }

    async componentDidMount() {
        await fetch(`${process.env.REACT_APP_MY_API_URL}/wp-json/wp/v2/testimonials?posts=5`).then((response) => {
            response.json().then((res) => {                
                this.setState({
                    tmonials: res
                })
               
            })
        })
    }

    render() {
        return (

            // <!-- Testimonial Start  -->
            <div className="section techwix-testimonial-section-02 techwix-testimonial-section-03 section-padding-02">
                <div className="container">
                    {/* <!-- Testimonial Wrap Start  --> */}
                    <div className="testimonial-wrap-02">
                        <div className="section-title text-center">
                            <h3 className="sub-title">Testimonial</h3>
                            <h2 className="title">Satisfied clients worldwide</h2>
                        </div>
                        <div className="testimonial-content-wrap-02">
                            <div className="swiper-container testimonial-02-active">
                                <Swiper
                                    spaceBetween={130}
                                    slidesPerView={2}                                                                                                    
                                    loop={true}
                                    autoplay={{
                                        delay:1000
                                    }}    
                                    pagination={{      
                                            el: ".testimonial-02-active .swiper-pagination",                                                                           
                                    }}
                                    modules={[Pagination, Autoplay]}        
                                   
                                    breakpoints={{
                                        0: {
                                            slidesPerView: 1,
                                        },
                                        576: {
                                            slidesPerView: 1,
                                            spaceBetween: 20,
                                        },
                                        768: {
                                            slidesPerView: 1,
                                        },
                                        992: {
                                            slidesPerView: 1,
                                        },
                                        1400: {
                                            slidesPerView: 2,
                                        },
                                    }}
                                >
                                    {
                                        
                                        this.state.tmonials ?
                                        
                                            this.state.tmonials.map((item, i) =>                                            
                                                <SwiperSlide key={i} className="swiper-slide">                                                
                                                    <div className="single-testimonial-02">
                                                        <div className="testimonial-thumb">
                                                            <img src={item.acf.photo.toString()} alt="" />
                                                        </div>
                                                        <div className="testimonial-content">
                                                            <img src={`${process.env.PUBLIC_URL}/images/testi-icon.png`} alt="" />
                                                            {parse("<p>" + item.content.rendered + "</p>")}
                                                            <span className="name">{item.title.rendered}</span>
                                                            <span className="designation"> / {item.acf.company_name}</span>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                            )
                                            : ''

                                            
                                    }                                   
                                </Swiper>

                                {/* <!-- Add Pagination --> */}
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- Testimonial Wrap End  --> */}
                </div>
            </div>
            // <!-- Testimonial End  -->
        )
    }
}

export default Testimonial